import React from "react";
import { ComponentContainer } from "../styled.js";
import { BandContainer } from "../styled.js";
import alinenImage from "../images/alinen.webp";
import { useLanguage } from "../i18n/LanguageContext";

const Band = () => {
  const { t } = useLanguage();
  const paragraphs = t.band.body.split("\n\n");

  return (
    <div id="band">
      <ComponentContainer>
        <br />
        <br />
        <h2>{t.band.title}</h2>
        <BandContainer>
          <div>
            {paragraphs.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
            <blockquote cite={t.band.desibeliReviewUrl}>
              <p>
                <em>{t.band.desibeliQuote}</em>
              </p>
              <footer>
                —{" "}
                <cite>
                  <a href={t.band.desibeliReviewUrl} target="_blank" rel="noopener noreferrer">
                    {t.band.desibeliAttribution}
                  </a>
                </cite>
              </footer>
            </blockquote>
          </div>

          <img src={alinenImage} alt="Alinen" />
        </BandContainer>
        <br />
        <br />
      </ComponentContainer>
    </div>
  );
};

export default Band;
